import script from "./Dfsv.vue?vue&type=script&lang=ts&setup=true"
export * from "./Dfsv.vue?vue&type=script&lang=ts&setup=true"

import "./Dfsv.vue?vue&type=style&index=0&id=4daaa11f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4daaa11f"]])

export default __exports__